module.exports = __webpack_public_path__ + "static/img/perk.68769d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/perk.png
// module id = Ugh2
// module chunks = 0